import React, { PropsWithChildren, useContext, useEffect, useRef, useState } from 'react';
import { ButtonProps } from './Button';
import classNames from 'classnames';
import buttonStyles from './Button.scss';
import styles from './DropDownItem.scss';
import { GroupContext } from '../layout';

export interface DropdownProps extends Omit<ButtonProps, 'onClick'> {
  onClick?: () => void;
}

export const Dropdown: React.FC<PropsWithChildren<DropdownProps>> = ({ children, onClick, ...props }) => {
  const groupCtx = useContext(GroupContext);

  const [show, setShow] = useState(false);
  const buttonRef = useRef<HTMLButtonElement>(null);
  const splitButtonRef = useRef<HTMLButtonElement>(null);
  const containerRef = useRef<HTMLDivElement>(null);

  const isSplit = onClick ? true : false;

  const handClick = (e: any) => {
    var kbEvent = e as React.KeyboardEvent<HTMLDivElement>;

    if (buttonRef.current?.contains(e.target as any) || splitButtonRef.current?.contains(e.target as any)) {
      return;
    }
    if (kbEvent.key == 'Tab') {
      if (containerRef.current?.contains(kbEvent.target as any)) {
        return;
      }
    }
    setShow(false);
  };

  useEffect(() => {
    ['dropdown-item-clicked'].forEach((event) => document.addEventListener(event, handClick, true));

    return function () {
      ['dropdown-item-clicked'].forEach((event) => document.removeEventListener(event, handClick, true));
    };
  }, []);

  return (
    <div className={classNames('btn-group', { show: show })}>
      <button
        id={props.id ? props.id : undefined}
        className={classNames(
          buttonStyles['au-btn'],
          {
            [buttonStyles['au-btn--secondary']]: props.mode == 'secondary',
            [buttonStyles['au-btn--block']]: props.size == 'block',
            'dropdown-toggle': !isSplit,
          },
          groupCtx.className,
          props.className,
        )}
        onClick={() => {
          if (onClick) onClick();
          else setShow(!show);
        }}
        disabled={props.disabled}
        aria-labelledby={props.describedBy || ''}
        title={props.title || undefined}
        role="button"
        aria-haspopup="true"
        aria-expanded="false"
        ref={buttonRef}>
        {props.label}
      </button>
      {isSplit ? (
        <button
          type="button"
          className={classNames(
            buttonStyles['au-btn'],
            {
              [buttonStyles['au-btn--secondary']]: props.mode == 'secondary',
            },
            'dropdown-toggle',
            'dropdown-toggle-split',
          )}
          disabled={props.disabled}
          aria-haspopup="true"
          aria-expanded="false"
          style={{ padding: '8px 18px', zIndex: 0, marginLeft: 1, borderTopLeftRadius: 0, borderBottomLeftRadius: 0 }}
          onClick={() => {
            console.log(show);
            setShow(!show);
          }}
          ref={splitButtonRef}>
          <span className="sr-only">Toggle Dropdown</span>
        </button>
      ) : (
        <></>
      )}
      <div
        className={classNames('dropdown-menu', { show: show }, styles['au-dropdownmenu'])}
        aria-labelledby="dropdownMenuLink"
        ref={containerRef}
        style={isSplit ? { left: 'auto', right: 0 } : {}}>
        {children}
      </div>
    </div>
  );
};
